var map = {
	"./albertsons.png": 9370,
	"./rite-aid.png": 8008,
	"./transparent-costco.webp": 7902,
	"./transparent-cvs.webp": 3057,
	"./transparent-kroger.webp": 7237,
	"./transparent-safeway.webp": 3079,
	"./transparent-walgreens.webp": 8443,
	"./transparent-walmart.webp": 9351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5379;